export function AroundTheHornIcon() {
  return (
    <svg
      aria-hidden="true"
      viewBox="0 0 48 48"
      fill="none"
      stroke="currentColor"
      strokeWidth="2.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    >
      <circle cx="24" cy="24" r="16" />
      <ellipse cx="24" cy="24" rx="6" ry="16" />
      <line x1="8" y1="24" x2="40" y2="24" />
      <path d="M10 16h28" />
      <path d="M10 32h28" />
    </svg>
  );
}
